export default () => ({
    user: null,
    company: null,
    token: null,
    role: null,
    permissions: []
})
